// extracted by mini-css-extract-plugin
module.exports = {"name":"_8e02b93c","link":"_b82ec01b"};